angular.module('gym.workouts', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.workouts', {
    url: '/workouts',
    abstract: true,
    template: '<ui-view>'
  }).state('gym.workouts.archivedWorkouts', {
    url: '/workouts/archived_list',
    template: require('templates/gyms/workouts/archived_list.html.slim')
  }).state('gym.workouts.optIn', {
    url: '/workouts/toggle',
    controller: 'WorkoutsOptInCtrl',
    template: require('templates/gyms/workouts/toggle.html.slim')
  }).state('gym.workouts.list', {
    url: '/workouts',
    template: require('templates/gyms/workouts/list.html.slim')
  }).state('gym.workouts.new', {
    url: '/workouts/new',
    template: require('templates/gyms/workouts/edit.html.slim')
  }).state('gym.workouts.edit', {
    url: '/workouts/:workoutId/edit',
    template: require('templates/gyms/workouts/edit.html.slim')
  }).state('gym.workouts.new_bulk_enrol', {
    url: '/bulk_enrols/new?report_id&workout_id&show_in_member_portal&show_history_in_member_portal&manageable_by_member',
    controller: 'BulkWorkoutEnrolCtrl',
    template: require('templates/gyms/workouts/bulk_enrol.html.slim'),
    resolve: {
      report: ["$stateParams", "$http", function($stateParams, $http) {
        var url;
        url = `/gyms/${$stateParams.gymId}/reports/${$stateParams.report_id}?for_workout_id=${$stateParams.workout_id}`;
        return $http.get(url).then(function(response) {
          return response.data;
        });
      }],
      workout: ["$stateParams", "Workouts", function($stateParams, Workouts) {
        return Workouts.all('workouts').get($stateParams.workout_id);
      }]
    }
  }).state('gym.workouts.members', {
    url: '/workouts/:workoutId/members',
    template: require('templates/gyms/workouts/members_list.html.slim')
  });
}]);
